<template>
    <div>
        <custom-button :class="additionalButtonClasses" @click.native="displayModal = true" :colourType="buttonType">
            {{action.title}}
        </custom-button>
        <portal to="destination">
            <large-model v-if="displayModal" :submitting="submittingModal" :title="action.title"
                         :confirmationString='`Are you sure you want to \"${action.title}\"`'
                         @removeFromDisplay="displayModal = false" @perform="perform()">
                <h3 class="text-lg leading-6 font-medium">
                    Set delivered quantity
                </h3>
                <div class="mb-4">
                    <p class="text-sm leading-5">
                        Please update the delivered quantities.
                    </p>
                </div>
                <div class="flex flex-col">
                    <goods-in-note-form-pagination :entities="orderItemEntities"  :action="action" :formData="formData" :propErrors="errors">
                    </goods-in-note-form-pagination>
                    <div class="mt-3" v-if="getField('delivery_notes')">
                        <component :is="getFieldComponent(getField('delivery_notes').type)" :field="getField('delivery_notes')" v-model="formData[getField('delivery_notes').name]">
                        </component>
                        <div v-show="errors.has(getField('delivery_notes').name)" class="text-red-600">{{
                            errors.first(getField('delivery_notes').name) }}
                        </div>
                    </div>
                    <div class="mt-3" v-if="getField('docket')">
                        <component :is="getFieldComponent(getField('docket').type)" :field="getField('docket')" v-model="formData[getField('docket').name]">
                        </component>
                        <div v-show="errors.has(getField('docket').name)" class="text-red-600">{{
                                errors.first(getField('docket').name) }}
                        </div>
                    </div>
                    <div v-show="errors.has('order')" class="text-red-600">{{
                            errors.first('order') }}
                    </div>
                </div>

            </large-model>
        </portal>
    </div>
</template>

<script>
    import LargeModel from "@/v3/models/LargeModel.vue";
    import CustomButton from "@/v3/Buttons/CustomButton.vue";
    import GoodsInNoteFormPagination from "@/v3/components/pagination/GoodsInNoteFormPagination.vue";

    export default {
        inject: ["$validator"],
        data() {
            return {
                displayModal: false,
                submittingModal: false
            }
        },
        components: {
            GoodsInNoteFormPagination,
            CustomButton,
            LargeModel
        },
        props: {
            action: {
                type: Object,
            },
            actionKey: {
                type: String
            },
            response: {
                type: Object
            },
            additionalButtonClasses:{
                type:String
            },
            buttonType:{
                type: String
            },
            redirectOnSuccess:{
                type: Boolean,
                default: true
            }
        },
        computed: {
            formData() {
                if (!this.action.fields) {
                    return {};
                }
                var payload = {};
                this.action.fields.forEach(function (field) {
                    if (field.value !== undefined) payload[field.name] = field.value;
                });
                return payload;
            },
            orderItemEntities() {
                if (!this.response) {
                    return null;
                }
                return this.response.entities.filter(entity => entity.rels.contains('order_item'));
            },
        },
        methods: {
            getItemFieldByOrderItemEntity(orderItemEntity) {
                return this.action.fields.get('items[' + orderItemEntity.entity.properties.get('id') + ']');
            },
            getField(key) {
                return this.action.fields.get(key);
            },
            getFieldComponent(type) {
                return type + '-input';
            },
            perform() {
                this.submittingModal = true;
                this.action.perform(this.formData).then(res => {
                    this.displayModal = false;
                    this.submittingModal = false;
                    this.$store.dispatch(
                        "setMessage",
                        this.messages(res).entity.properties.get("success")
                    );
                    if(this.redirectOnSuccess) {
                        this.$router.go(0);
                    }
                    this.$emit('success');
                }).catch(error => {
                    this.submittingModal = false;
                    if (error.response.status !== 422) {
                        alert('There was an error processing your request.' + error);
                    }
                    this.$setLaravelValidationErrorsFromResponse(
                        JSON.parse(error.response.text)
                    );
                    // this.displayModal = false;
                });
            },
            messages(response) {
                return response.body.entities
                    .filter(function (entity) {
                        return entity.rels.contains("status-messages");
                    })
                    .first();
            }
        },
    }
</script>

<style lang="scss">
    .goods-in-order-items label {
        display: none;
    }
</style>
